import { makeAutoObservable } from "mobx";

export interface Address {
  id?: string;
  street?: string;
  unit?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface Customer {
  id: string;
  name: string;
  netSuiteName?: string;
  address?: Address;
  customerEmails?: CustomerEmail[];
  isActive?: boolean;
}

export interface Address {
  id?: string;
  street?: string;
  unit?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface CustomerEmail {
  id: string;
  customerId: string;
  email: string;
  emailType: string;
}

export class CustomerModel implements Customer {
  readonly id: string;
  name: string;
  netSuiteName?: string;
  address?: Address;
  customerEmails?: CustomerEmail[];
  isActive: boolean = true;

  constructor(customer: Customer) {
    makeAutoObservable(this);
    this.id = customer.id;
    this.name = customer.name;
    this.netSuiteName = customer.netSuiteName;
    this.address = customer.address;
    this.customerEmails = customer.customerEmails;
    this.isActive = customer.isActive ?? true;
  }

  get canSave() {
    return this.name.trim().length > 0;
  }
  setField<K extends keyof CustomerModel>(field: K, value: CustomerModel[K]) {
    (this[field] as CustomerModel[K]) = value;
  }
}

export const formatAddress = (a?: Address) => {
  if (!a) return '';
  const street = [a.street, a.unit].filter(Boolean).join(', ');
  const cityStateZip = [a.city, [a.state, a.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  return [street, cityStateZip].filter(Boolean).join(', ');
};

export const valuesToEmails = (values: string[], type: string): CustomerEmail[] =>
  [...new Set(values.map(v => v.trim()).filter(Boolean))]
    .map(email => ({ id: '', customerId: '', email, emailType: type }));